import script from "./ProductRegister.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductRegister.vue?vue&type=script&setup=true&lang=ts"

import "./ProductRegister.vue?vue&type=style&index=0&id=956ed952&lang=css"

const __exports__ = script;

export default __exports__